import { useState } from "react";
import { store, useStruct, useTick } from "../../plc-sim/store";
import type { Issue } from "../../plc-sim/diagnostics";

const COLOR: Record<Issue["level"], string> = {
  error: "var(--color-destructive)",
  warning: "#e0a800",
  info: "#5b8def",
};

export function ErrorBar({ onGoto }: { onGoto: (issue: Issue) => void }) {
  useStruct();
  useTick();
  const [open, setOpen] = useState(false);
  const issues = store.issues;
  const errors = issues.filter((i) => i.level === "error").length;
  const warnings = issues.filter((i) => i.level === "warning").length;

  return (
    <div className="relative">
      {open && (
        <div
          className="absolute bottom-7 right-0 z-40 max-h-52 w-[min(92vw,26rem)] overflow-y-auto rounded-md border border-border bg-card shadow-lg"
          dir="rtl"
        >
          {issues.length === 0 && (
            <p className="p-3 text-[11px] text-muted-foreground">✓ لا توجد أخطاء</p>
          )}
          {issues.map((i) => (
            <button
              key={i.id}
              onClick={() => onGoto(i)}
              className="flex w-full items-center gap-2 border-b border-border/60 px-3 py-1.5 text-right text-[11px] hover:bg-secondary"
            >
              <span
                className="h-2 w-2 shrink-0 rounded-full"
                style={{ background: COLOR[i.level] }}
              />
              <span className="shrink-0 font-mono text-[10px] uppercase text-muted-foreground">
                {i.level}
              </span>
              <span className="min-w-0 flex-1 truncate">{i.msg}</span>
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 rounded px-2 py-0.5 text-[10px] hover:bg-secondary"
        title="لوحة الأخطاء"
      >
        {issues.length === 0 ? (
          <span style={{ color: "var(--lad-live)" }}>✓ لا توجد أخطاء</span>
        ) : (
          <>
            {errors > 0 && (
              <span style={{ color: COLOR.error }}>الأخطاء ({errors})</span>
            )}
            {warnings > 0 && (
              <span style={{ color: COLOR.warning }}>تنبيهات ({warnings})</span>
            )}
            {errors === 0 && warnings === 0 && <span>ملاحظات ({issues.length})</span>}
          </>
        )}
        <span className="text-muted-foreground">{open ? "▾" : "▴"}</span>
      </button>
    </div>
  );
}
